











import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: { Header, Footer }
})
export default class App extends Vue {
  public minHeight: number = 0;
  created() {
    this.minHeight = document.documentElement.clientHeight - 190 + 1;
  }
}
